import { createContext, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const MeContext = createContext(null);

export const useMe = () => useContext(MeContext);

export const MeProvider = ({ children }) => {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api("get", "/me").then(setMe).catch(() => setError(true));
  }, [api]);

  if (error) return <p className="p-10 text-center" data-testid="me-error">Could not load your account. Please refresh.</p>;
  if (!me) return <div className="p-10 text-center text-[#5C5850]" data-testid="me-loading">Loading your portal…</div>;
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
};
